import { Dispatch, SetStateAction } from 'react';
import { useFilterRes } from '../api/hooks/useFilter';
import { getSupportedDefaultMatchMode } from './filters/getSupportedDefaultMatchMode';
import { isEmptyValue } from './managerUtils';

export const processFetchedSlaveFilter = (
  response: useFilterRes,
  subsetId: string,
  dataset: any,
  setSlaveLazyStates: Dispatch<SetStateAction<any>>,
  setSlaveFilter: Dispatch<SetStateAction<any>>
) => {
  if (response && response.datasetId === subsetId) {
    if (dataset?.items && response.filter.items) {
      // Update default matchMode value for multiCheckbox filters
      setSlaveLazyStates((oldAllSlaves) => {
        const oldLazyState = oldAllSlaves[subsetId] ?? {};
        const newFilters = { ...(oldLazyState.filters || {}) };

        dataset.items.forEach((column) => {
          if (column.filterParam) {
            const filterItem = response.filter.items.find(
              ({ name }) => name === column.filterParam
            );
            if (filterItem) {
              const newMatchMode = getSupportedDefaultMatchMode(
                filterItem,
                column.type
              );
              const hasColumnFilter =
                newFilters[column.name]?.constraints?.[0] !== undefined;

              if (hasColumnFilter) {
                // Keep the existing matchMode once a value is set; rewriting it would pair that value with a foreign matchMode.
                if (
                  isEmptyValue(newFilters[column.name].constraints[0].value)
                ) {
                  newFilters[column.name].constraints[0].matchMode =
                    newMatchMode;
                }
              } else {
                newFilters[column.name] = {
                  operator: 'and',
                  constraints: [{ value: null, matchMode: newMatchMode }],
                };
              }
            }
          }
        });

        return {
          ...oldAllSlaves,
          [subsetId]: { ...oldLazyState, filters: newFilters },
        };
      });
    }
    setSlaveFilter(response.filter);
  }
};
